import { useAuth } from '@msrceng/auth';
import { useThemeData } from '@msrceng/theme';
import { useUpdateMySettingsMutation } from '../api';
import { useLocalStorageThemeKey } from './useAppThemeConnector/useLocalStorageThemeKey';
/**
 * Returns a function to set the theme that intelligently updates
 * the theme depending on whether the user is signed in or not.
 */
export const useSetThemeBothApiAndLocal = () => {
    const { isApiTokenLoaded } = useAuth();
    const { mutateAsync } = useUpdateMySettingsMutation();
    const { setTheme } = useThemeData();
    const [, setLocalStorageTheme] = useLocalStorageThemeKey();
    return (theme) => {
        if (isApiTokenLoaded) {
            mutateAsync({ theme });
        }
        setTheme(theme);
        setLocalStorageTheme(theme);
    };
};
